import { v4 as uuidv4 } from "uuid";

/**
 * Generate a random UUID v4.
 */
export const generateUuid = (): string => uuidv4();
